import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientService } from 'src/app/patients/patient.service';
import { GridApi } from 'ag-grid-community';
import { SharedService } from 'src/app/utils/shared.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { DetailComponent } from '../detail/detail.component';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import * as CommonConstants from '../../utils/common.constants';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-medical-file',
  templateUrl: './add-medical-file.component.html',
  styleUrls: ['./add-medical-file.component.scss']
})
export class AddMedicalFileComponent implements AfterViewInit {

  viewMode = 'detailTab';
  // viewMode = 'upDatesTab';
  rightTabs = true;
  patientSearchForm: FormGroup;
  medicalFiles;
  selectedMedicalFile;
  PARAM_KEY = [CommonConstants.TREATMENT_TYPE, CommonConstants.ROUTE,
  CommonConstants.PRESENTATION, CommonConstants.DOSAGE, CommonConstants.STATUS];
  masterValues = [];
  treatmentTypes;
  routes;
  presentations;
  dosages;
  medFileId;
  userId;
  url='';
  picPatientId;
  columnDefs = [
    { headerName: 'Patient Number', field: 'patientNumber' },
    { headerName: 'First Name', field: 'persoVaFirstnameEn' },
    { headerName: 'Last Name', field: 'persoVaLastnameEn' },
    { headerName: 'DOB', field: 'persoDtBirthDate' },
    { headerName: 'Gender', field: 'gendeCode' }
  ];
  rowData = [];
  selectedPatient = {};
  selectedMedFile = {};
  gridApi: GridApi;
  status;
  modalRef: BsModalRef;
  findPatientModal;
  patientMedicalFileDtls;
  patientDtls;
  @ViewChild(DetailComponent, { static: false }) childDetail: DetailComponent;
  @ViewChild('selectPatient', { static: false }) selectPatient: ModalDirective;
  transferMedfId: any;
  newFile: boolean;
  fileStatus: any;
  constructor(private modal: NgbModal, public router: Router, 
        private formBuilder: FormBuilder, private patientService: PatientService,
        private sharedService: SharedService, private medFileService: MedicalFileService, 
        private masterService: MasterService
  ) {
    /* this.sharedService.medicalFileStatus$.subscribe(res => {
      this.fileStatus = res;
    }) */
    this.getFormGroup();
    if (this.router.getCurrentNavigation()!=null && this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
      if(this.router.getCurrentNavigation().extras.state.patientDtls){
        this.patientDtls = this.router.getCurrentNavigation().extras.state.patientDtls;
        this.selectedPatient["patieId"]=this.patientDtls.patieId;
      }else if(this.router.getCurrentNavigation().extras.state.medicalFileDtls){
        this.patientMedicalFileDtls = this.router.getCurrentNavigation().extras.state.medicalFileDtls;
      }else if(this.router.getCurrentNavigation().extras.state.transferMedfId){
        this.transferMedfId=this.router.getCurrentNavigation().extras.state.transferMedfId;
      }
      else if(this.router.getCurrentNavigation().extras.state.newFile){
        this.newFile=true;
      }
    }

  }

  ngOnInit() {
    this.picPatientId=null;
    this.loadMaster();
    this.userId = +localStorage.getItem(CommonConstants.USERID);
    if (this.patientDtls) {
      this.addNewMedicalFile(this.patientDtls);
      this.picPatientId=this.patientDtls["patieId"];
    }
    else if (this.patientMedicalFileDtls) {
      let row = {
        "medfiId": this.patientMedicalFileDtls.medfiId,
        "patieId": this.patientMedicalFileDtls.patieId
      }
      this.medFileId = this.patientMedicalFileDtls.medfiId;
      //this.childDetail.medFileForm.enable();
      this.getMedFileDetails(row);
      this.picPatientId=this.patientMedicalFileDtls.patieId;
    } 
    else if(this.transferMedfId){
      let searchData={
        'medfiId':this.transferMedfId
      }
      this.medFileService.searchMedicalFiles(searchData).subscribe(response => {
        if(response['code']='0' && response['result'] && response['result'].length > 0){
          this.patientMedicalFileDtls=response['result'][0];
          let row = {
            "medfiId": this.patientMedicalFileDtls.medfiId,
            "patieId": this.patientMedicalFileDtls.patieId
          }
          this.picPatientId=this.patientMedicalFileDtls.patieId;
          this.getMedFileDetails(row);
        }
      }, error => {
        console.log('Error Occured while fetching medical file details');
      })
      
    }
    else if (this.newFile){
      this.changePatient();
    }
    else{
      this.router.navigate(['/medicalFiles']);
    }
    this.fileStatus=localStorage.getItem(CommonConstants.FILE_STATUS);
    this.getPatientImage(this.picPatientId);
  }

  ngAfterViewInit() {

  }

  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.treatmentTypes = this.masterValues.filter(master => master.paramKey === CommonConstants.TREATMENT_TYPE);
        this.routes = this.masterValues.filter(master => master.paramKey === CommonConstants.ROUTE);
        this.presentations = this.masterValues.filter(master => master.paramKey === CommonConstants.PRESENTATION);
        this.dosages = this.masterValues.filter(master => master.paramKey === CommonConstants.DOSAGE);
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);

      }
    });
  }

  private getFromGroup() {
    this.patientSearchForm = this.formBuilder.group({
      'patieId': new FormControl(),
      'persoVaFirstnameEn': new FormControl(),
      'persoDtBirthDate': new FormControl(),
      'persoVaLastnameEn': new FormControl()
    });
  }

  changePatient() {
    this.rowData = [];
    this.findPatientModal = true;
    //this.modalRef = this.modalService.show(this.selectPatient,{ class: 'modal-lg' });  
    //this.modal.open(selectPatient, { size: 'lg', container: '.page-content'}); 
  }
  closeChangePatient() {
    this.findPatientModal = false;
  }

  rightSidebTabs() {
    this.rightTabs = !this.rightTabs;
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }


  private getFormGroup() {
    this.patientSearchForm = this.formBuilder.group({
      'name': new FormControl(),
      'persoVaFirstname': new FormControl(),
      'persoVaLastname': new FormControl(),
      'patientNumber': new FormControl(),
      'persoDtBirthDate': new FormControl()
    })
  }


  searchPatients() {
    this.patientService.getPatients(this.patientSearchForm.value).subscribe(res => {
      this.rowData = [];
      if (res && res["result"]) {
        let response = res["result"];
        response = response.map(item => ({
          ...item,
          'expanded': false,
        }));
        this.rowData = res["result"];
      }
    })
  }

  getMedFileDetails(row) {
    // event.expanded = !event.expanded
    this.patientService.getPatientById(row["patieId"]).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        this.medicalFiles = response["medicalFiles"];
        if (this.patientMedicalFileDtls) {
          let selectedMedicalFile = this.medicalFiles.filter(item => item.medfiId === this.patientMedicalFileDtls.medfiId)[0];
          let patient = {
            "persoVaFirstnameEn": this.patientMedicalFileDtls.firstName,
            "persoVaLastnameEn":this.patientMedicalFileDtls.lastName,
            "persoDtBirthDate": this.patientMedicalFileDtls.dob,
            "orgsmId": this.patientMedicalFileDtls.orgsmId,
            "patieId": row["patieId"],
            "patientNumber":response["patientNumber"]
          }
          this.addMedFileDetails(patient, selectedMedicalFile);


        }
      }

    })
    //  this.modal.dismissAll();
  }

  addMedFileDetails(patient, medFiles) {
    if (patient){
      this.selectedPatient = patient;
    }
    this.selectedMedFile = medFiles;
    this.selectedMedicalFile = medFiles.medfiVaReference+'-'+medFiles.medfiVaMainDiagnostic;
    this.viewMode = 'detailTab';
    // this.viewMode = 'upDatesTab';
    this.modal.dismissAll(); this.findPatientModal = false;
    this.childDetail.medFileForm.enable();
    this.childDetail.medFileForm.patchValue(medFiles);
    this.medFileId = medFiles.medfiId;
    this.sharedService.nextMedicalFiledId(medFiles.medfiId);
    this.medFileService.getMedFiles(medFiles.medfiId).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        this.sharedService.medicalFileStatus(response['status']);
        localStorage.setItem(CommonConstants.FILE_STATUS, response['mestaCode']);
        this.childDetail.medicalFileDtls = response;
        this.childDetail.diagnosticAssociates =  this.childDetail.setMasterMapping(response["diagnosticAssociates"]);
        this.childDetail.personalList = this.childDetail.setMasterMapping(response["personalAtcd"]);
    /*     this.childDetail.childTreatment.medicationtList = response["medication"].map(item => ({
          ...item,
          status: item.statuCode ? this.status.find(obj => obj.id === +item.statuCode).value : null,
          route: item.routeCode ? this.routes.find(obj => obj.id === +item.routeCode).description : null,
          presentation: item.preseCode ? this.presentations.find(obj => obj.id === +item.preseCode).description : null,
          dosage: item.dosagCode ? this.dosages.find(obj => obj.id === +item.dosagCode).description : null,
        })) */
        if(this.transferMedfId){
          this.viewMode = 'askTransferTab';
        }
      }
    })
  }

  saveMedFiles() {

  }

  changeMedicalFile(newMedicalFile) {
    //this.selectedMedicalFile = newMedicalFile;
    this.addMedFileDetails(null, newMedicalFile);
  }

  addNewMedicalFile(pateint) {
    this.selectedMedicalFile = "New Appoitment";
    this.selectedPatient = pateint;
    this.findPatientModal = false;
    if(this.childDetail){
      this.childDetail.resetMedicalFile();
      this.childDetail.medFileId=null;
      this.childDetail.medicalFileDtls=null;
      this.childDetail.medFileForm.enable();
    }
    this.medFileId=null;
    this.getMedFileDetails(pateint);
   this.getPatientImage(pateint["patieId"]);
  }
  addNewMedicalFileForSelectedPAtient() {
    this.selectedMedicalFile = "New Appoitment";
    this.childDetail.resetMedicalFile();
    this.medFileId=null;
    this.childDetail.medFileId=null;
    this.childDetail.medicalFileDtls=null;
  }
  addpatient() {
    this.router.navigate(['/addPatient']);
  }
  getPatientImage(patieId){
    if(patieId!=null){
  this.masterService.getPatientImageById(CommonConstants.PATIENT,patieId).subscribe(res => {
    if (res['code'] == 'S0000') {
      let response = res['result'];
      if (response['image'] != null) {
        this.url = 'data:image/png;base64,' + response['image'];
      } else {
        this.url = '';
      }
    } else {
      this.url = '';
    }

  })
}
}
}
